import React, { useMemo } from "react";
import { createMarkup } from "../../../../Services/utils";
import { TypeQuestions } from "../../../../types";

type Props = {
  option: string;
  correct_option: string;
  optionIndex: number;
};

const SingleOption = ({ option, correct_option, optionIndex }: Props) => {
  const isCorrectOption = useMemo(() => {
    return (
      (correct_option === "a" && optionIndex === 0) ||
      (correct_option === "b" && optionIndex === 1) ||
      (correct_option === "c" && optionIndex === 2) ||
      (correct_option === "d" && optionIndex === 3)
    );
  }, [correct_option, optionIndex]);
  return (
    <div
      className={
        "text-white border rounded p-2 my-1" +
        (isCorrectOption
          ? " font-weight-bold rightQuestion-bg"
          : "")
      }
    >
      <span dangerouslySetInnerHTML={createMarkup(option)} />
    </div>
  );
};

type props = {
  questionData: TypeQuestions;
};

const Options = ({ questionData }: props) => {
  return (
    <>
      {["a", "b", "c", "d"].map((each, index) => (
        <SingleOption
          key={index}
          option={questionData["option_" + each]}
          correct_option={questionData.correct_option}
          optionIndex={index}
        />
      ))}
    </>
  );
};

export default Options;
